import type { APIShelfFile } from '~~/entities/api'

export const GHOST_SLIDE_ID = -1

export interface Slide {
  id: number
  media_id?: number
  deck_id: number
  title: string
  description?: string
  type: SlideTypes
  company_id?: number
  file_id?: number
  page_number?: number
  site_id?: number
  site_image?: string
  project_id?: number
  model_id?: number
  camera_id?: number
  order?: number
  image?: PDFPageImage
  preview?: PDFPageImage
  file?: APIShelfFile
  url?: string
  model_camera?: ModelCameraTitle
  site_camera?: SiteCameraTitle
  content_url?: string
  title_visible_in_3d_model?: boolean
  scene_id?: number
  asset_id?: number
}

export enum SlideTypes {
  Header = 'H',
  Image = 'I',
  Video = 'V',
  PDF = 'P',
  Dynamic = 'D',
  Model = 'M',
  Meeting = 'E',
  Scene = 'W',
  Site = 'S',
  ThreeSixty = 'X',
}

export enum SlideTypeLabels {
  H = 'Header',
  I = 'Image',
  V = 'Video',
  P = 'PDF',
  D = 'Dynamic',
  M = '3D',
  E = 'Meeting',
  W = 'Scene',
  S = 'Site',
  X = '360 Scene',
}

export interface PDFPageImage {
  id?: number
  zoom_level?: number
  url?: string
  page_number?: number
}
export interface ModelCameraTitle {
  title?: string
  preview?: string
  model_title?: string
}
export interface SiteCameraTitle {
  title?: string
  preview?: string
}

export enum UploadType {
  Existing = 'existing',
  Upload = 'upload',
  Copy = 'copy',
}

export interface SlideImage {
  id: number
  page_number: number
  url: string
  zoom_level: number
}
export interface SlideToBeAdded {
  index: number
  type: SlideTypes
}
